var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"session":_vm.session,"participant":_vm.participant}},[_c('result',{staticClass:"px-3",attrs:{"session":_vm.session,"ratings":_vm.ratings,"resultIdx":_vm.step == 'result1' ? 1 : 2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }